export const GoogleDriveIcon = (props: React.ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M3.20962 15.7121L3.91523 17.0762C4.06185 17.3634 4.27261 17.589 4.52003 17.7531L7.04007 12.8711H2C2 13.189 2.07331 13.507 2.21993 13.7942L3.20962 15.7121Z"
        fill="#0066DA"
      />
      <path
        d="M9.99996 7.12812L7.47993 2.24609C7.23251 2.4102 7.02174 2.63584 6.87512 2.92301L2.21993 11.9486C2.07601 12.2296 2.00019 12.5478 2 12.8717H7.04007L9.99996 7.12812Z"
        fill="#00AC47"
      />
      <path
        d="M15.4813 17.7531C15.7288 17.589 15.9395 17.3634 16.0861 17.0762L16.3794 16.5121L17.7814 13.7942C17.9281 13.507 18.0014 13.189 18.0014 12.8711H12.9609L14.0335 15.2301L15.4813 17.7531Z"
        fill="#EA4335"
      />
      <path
        d="M10.0044 7.12818L12.5244 2.24615C12.277 2.08205 11.9929 2 11.6997 2H8.30911C8.01587 2 7.7318 2.09231 7.48438 2.24615L10.0044 7.12818Z"
        fill="#00832D"
      />
      <path
        d="M12.9554 12.8711H7.03566L4.51562 17.7531C4.76305 17.9172 5.04712 17.9993 5.34036 17.9993H14.6507C14.944 17.9993 15.2281 17.907 15.4755 17.7531L12.9554 12.8711Z"
        fill="#2684FC"
      />
      <path
        d="M15.4524 7.43581L13.1248 2.92301C12.9782 2.63584 12.7675 2.4102 12.52 2.24609L10 7.12812L12.9599 12.8717H17.9908C17.9908 12.5537 17.9175 12.2358 17.7709 11.9486L15.4524 7.43581Z"
        fill="#FFBA00"
      />
    </svg>
  );
};
